export const SMALL_SCREEN_BREAKPOINT_WIDTH = 790
export const LARGE_SCREEN_BREAKPOINT_WIDTH = 1148
